<template>
    <div class="grid">
        <div class="unit whole">
            <h1>Reporting</h1>
            <p class="lead">See RTQ results at class, group or pupil level.</p>
        </div>
    </div>
    <ReportingOverviewComp :pupils="pupils" :classes="classes" :groups="groups" />
    <v-overlay
        :model-value="!(isLoaded?.pupils || isLoaded?.classes || isLoaded?.groups)"
        class="align-center justify-center"
    >
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

definePage({ meta: { area: 'reporting' } });

const store = useTeacherStore();
store.fetchPupils();
store.fetchClasses();
store.fetchGroups();

const { pupils, classes, groups, isLoaded } = storeToRefs(store);
</script>
